<template>
<div>
    <submission-title
        :form_name="form_submission.ppe_register.item.name"
        :form_status="form_submission.form_status"
    />

    <submission-subtitle
        :form_status="form_submission.form_status"
        hide_status
    />

    <response-text
        :question="`Number of ${form_submission.ppe_register.item.name}`"
        :answer="form_submission.ppe_register.count"
    />

    <response-comments :comments="form_submission.comments" />

</div>
</template>

<script>
import SubmissionTitle from "./SubmissionTitle";
import SubmissionSubtitle from "./SubmissionSubtitle";
import ResponseText from "./responses/ResponseText";
import ResponseComments from "./responses/ResponseComments.vue";

export default {
    name: "PpeRegisterSubmission",
    components: {
        SubmissionTitle,
        SubmissionSubtitle,
        ResponseText,
        ResponseComments,
    },
    props: {
        form_submission: {
            type: Object,
            required: true,
        },
    },
}
</script>
